import React from 'react';
import { Modal } from 'antd';
import useApi from '../../hooks/useApi';
import useUserType from '../../hooks/useUserType';

const ModalDelete = ({ visible, id, onCancel, onSuccess }) => {
  const userType = useUserType();

  const { callApi: deleteDashboard } = useApi(`https://vision.alfama.com/api/delete/dashboards/${id}`, {
    method: 'DELETE',
    includeToken: true,
    successMessage: 'Dashboard excluído com sucesso!',
    errorMessage: 'Erro ao excluir dashboard'
  });

  if (userType !== 'administrador') {
    return (
      <Modal
        title={
          <div className="flex items-center gap-2 text-red-500">
            Aviso
          </div>
        }
        open={visible}
        onCancel={onCancel}
        footer={null}
      >
        <p>Somente administradores podem excluir dashboards.</p>
      </Modal>
    );
  }

  const handleConfirm = async () => {
    try {
      await deleteDashboard();
      onCancel();
      onSuccess();
    } catch (error) {
      console.error('Erro ao excluir dashboard:', error);
    }
  };

  return (
    <Modal
      title={
        <div className="flex items-center gap-2 text-red-500">
          Confirmação de Exclusão
        </div>
      }
      open={visible}
      onCancel={onCancel}
      onOk={handleConfirm}
      okText="Confirmar"
      cancelText="Cancelar"
      okButtonProps={{ 
        danger: true,
        className: 'bg-red-500'
      }}
    >
      <p>Tem certeza que deseja excluir o ID: <strong>{id}</strong>?</p>
      <p>Esta ação não poderá ser desfeita.</p>
    </Modal>
  );
};

export default ModalDelete;